import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'

import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash'
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit'
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus'
import { faBroom } from '@fortawesome/free-solid-svg-icons/faBroom'
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye'
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave'
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser'
import { faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons/faHandHoldingUsd'
import { faComments } from '@fortawesome/free-solid-svg-icons/faComments'
import { faEraser } from '@fortawesome/free-solid-svg-icons/faEraser'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint'
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock'
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle'
import { faColumns } from '@fortawesome/free-solid-svg-icons/faColumns'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faTrash)
library.add(faEdit)
library.add(faUserPlus)
library.add(faBroom)
library.add(faEye)
library.add(faSave)
library.add(faUser)
library.add(faHandHoldingUsd)
library.add(faComments)
library.add(faEraser)
library.add(faArrowLeft)
library.add(faPrint)
library.add(faLock)
library.add(faBars)
library.add(faPlus)
library.add(faTimesCircle)
library.add(faColumns)

Vue.component('fa-icon', FontAwesomeIcon)
